export const GET_ABOUT_US_REQUEST = 'GET_ABOUT_US_REQUEST'
export const GET_ABOUT_US = 'GET_ABOUT_US'

export const UPDATE_ABOUT_US_REQUEST = 'UPDATE_ABOUT_US_REQUEST'
export const UPDATE_ABOUT_US = 'UPDATE_ABOUT_US'

export const GET_ABOUT_US_REQUEST_PENDING = 'GET_ABOUT_US_REQUEST_PENDING'
export const GET_ABOUT_US_REQUEST_SUCCESS = 'GET_ABOUT_US_REQUEST_SUCCESS'
export const GET_ABOUT_US_REQUEST_ERROR = 'GET_ABOUT_US_REQUEST_ERROR'

export const CHANGE_ABOUT_US_REQUEST_PENDING = 'CHANGE_ABOUT_US_REQUEST_PENDING'
export const CHANGE_ABOUT_US_REQUEST_SUCCESS = 'CHANGE_ABOUT_US_REQUEST_SUCCESS'
export const CHANGE_ABOUT_US_REQUEST_ERROR = 'CHANGE_ABOUT_US_REQUEST_ERROR'

